import "./styles.css";

const form = document.querySelector<HTMLFormElement>("#early-access");
const hero = document.querySelector<HTMLElement>(".hero");
const emailInput = document.querySelector<HTMLInputElement>("#email");
const statusEl = document.querySelector<HTMLParagraphElement>("#form-status");
const button = form?.querySelector<HTMLButtonElement>('button[type="submit"]');
const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

type ApiResponse = {
  ok: boolean;
  message?: string;
};

const setStatus = (message: string, state: "idle" | "success" | "error" = "idle") => {
  if (!statusEl) return;
  statusEl.textContent = message;
  statusEl.dataset.state = state;
};

const setPending = (isPending: boolean) => {
  if (!button || !emailInput) return;
  button.disabled = isPending;
  emailInput.disabled = isPending;
  form?.classList.toggle("is-submitting", isPending);
};

form?.addEventListener("submit", async (event) => {
  event.preventDefault();

  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  const data = new FormData(form);
  const payload = {
    email: String(data.get("email") ?? "").trim(),
    website: String(data.get("website") ?? ""),
    source: "cirentra-coming-soon"
  };

  setPending(true);
  setStatus("");

  try {
    const response = await fetch("/api/early-access", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const result = (await response.json().catch(() => ({}))) as ApiResponse;

    if (!response.ok || !result.ok) {
      throw new Error(result.message || "We could not add you just yet.");
    }

    form.reset();
    setStatus(result.message || "You are on the list. We will be in touch soon.", "success");
  } catch (error) {
    const message = error instanceof Error ? error.message : "We could not add you just yet.";
    setStatus(message, "error");
  } finally {
    setPending(false);
  }
});

if (hero) {
  let animationFrame = 0;

  const resetParallax = () => {
    hero.style.setProperty("--parallax-x", "0");
    hero.style.setProperty("--parallax-y", "0");
  };

  const updateParallax = (event: PointerEvent) => {
    if (reducedMotionQuery.matches || event.pointerType === "touch") return;

    const rect = hero.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;

    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(() => {
      hero.style.setProperty("--parallax-x", x.toFixed(3));
      hero.style.setProperty("--parallax-y", y.toFixed(3));
    });
  };

  hero.addEventListener("pointermove", updateParallax);
  hero.addEventListener("pointerleave", resetParallax);
  reducedMotionQuery.addEventListener("change", resetParallax);
  resetParallax();
}
